import { BeautifulMentionsTheme } from "lexical-beautiful-mentions";

export const beautifulMentionsTheme: { beautifulMentions: BeautifulMentionsTheme } = {
  beautifulMentions: {
    "@": "editor-mention",
    "@Focused": "editor-mention-focused",
  },
};
